const supplierSchema = [
    {
      name: 'supplier_name',
      label: 'Supplier Name',
      type: 'text',
      required: true,
      placeholder: 'Name of the Supplier',
      disabled: false,
    },
    {
      name: 'email',
      label: 'Email Address',
      type: 'email',
      required: false,
      placeholder: 'Email Address',
      disabled: false,
      validation: {
        pattern: {
          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          message: 'Please enter a valid email address'
        }
      }
    },
    {
      name: 'contact_number',
      label: 'Contact Number',
      type: 'text',
      required: true,
      placeholder: 'Primary Contact Number',
      disabled: false,
      validation: {
        pattern: {
          value: /^(\+\d{1,3}\s?\d{10}|\+\d{13}|\d{10})$/,
          message: 'Please enter a valid phone number (10 digits or +country code followed by 10 digits)'
        }
      }
    },
    {
      name: 'address',
      label: 'Address',
      type: 'textarea',
      required: false,
      placeholder: 'Physical Address',
      disabled: false,
    },
    {
        name: 'products_supplied',
        label: 'Products Supplied',
        type: 'products-supplied',
        required: false,
        placeholder: '',
        disabled: false,
    },
    {
      name: 'lead_time',
      label: 'Lead Time (days)',
      type: 'number',
      required: false,
      placeholder: 'Average delivery lead time',
      disabled: false,
    },
  ];
  
  export default supplierSchema;
